// Oyun modu kayıt yapısı (istemci). Yeni mod: modes/<ad>/index.js oluşturup buraya ekleyin.
import quiz from "@/modes/quiz";
import wheel from "@/modes/wheel";
import guess from "@/modes/guess";
import { bingo, boardsort, sort, written } from "@/modes/activity";

export const MODES = Object.fromEntries([quiz, wheel, guess, bingo, sort, written, boardsort].map((m) => [m.key, m]));

export const getMode = (key) => MODES[key];
